import { useState } from 'react'
import { PMPSectionHeading } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import ScreeningFeedback from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/ScreeningFeedback'
import { useScreeningReportState } from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/hooks/useScreeningReportState'
import FeedbackButton from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/components/FeedbackButton'
import ScreeningReportDisplay from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/ScreeningReportDisplay'
import { Dialog } from '@mui/material'

export default function ScreeningReportViewer({
  screeningReportData,
  screeningAssessmentReports = [],
  screeningSections,
  screeningEmrSectionDataList,
  screeningReportTemplateData,
  bookedEventInfo,
  mentorProfileData,
  screeningReportVisible,
  setScreeningReportVisible,
  setScreeningReportData,
}) {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false)

  // Use focused hooks
  const { addToFeedbackLog, hasFeedbackLog } = useScreeningReportState(
    screeningReportData,
    setScreeningReportData,
  )

  const createFeedbackLogEntry = () => ({
    id: Date.now(),
    timestamp: new Date().toISOString(),
    feedback: 'Feedback submitted',
  })

  const handleShowFeedback = () => setShowFeedbackForm(true)
  const handleHideFeedback = () => setShowFeedbackForm(false)

  const handleAfterSubmitFeedback = () => {
    const feedbackEntry = createFeedbackLogEntry()
    addToFeedbackLog(feedbackEntry)
  }

  const toggleVisibility = () => setScreeningReportVisible((prev) => !prev)

  if (!screeningReportData) return null

  return (
    <>
      <PMPSectionHeading>
        Screening Report{' '}
        <span
          style={{
            textDecoration: 'none',
            fontSize: '12px',
            fontWeight: '400',
            cursor: 'pointer',
          }}
          onClick={toggleVisibility}
        >
          {screeningReportVisible ? 'Hide' : 'Show'}
        </span>
      </PMPSectionHeading>

      {screeningReportVisible && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <ScreeningReportDisplay
            reportData={screeningReportData}
            screeningAssessmentReports={screeningAssessmentReports}
            screeningSections={screeningSections}
            screeningReportTemplateData={screeningReportTemplateData}
            bookedEventInfo={bookedEventInfo}
            mentorProfileData={mentorProfileData}
            emrSectionDataList={screeningEmrSectionDataList}
            removeBottomBorder
          />
          <div
            className="d-flex align-items-center justify-content-center gap-2 p-2 w-100"
            style={{
              maxWidth: '794px',
              background: 'white',
              borderLeft: '1px solid #000',
              borderRight: '1px solid #000',
              borderBottom: '1px solid #000',
            }}
          >
            <FeedbackButton onShowFeedback={handleShowFeedback} disabled={hasFeedbackLog()} />
          </div>
        </div>
      )}

      <Dialog open={showFeedbackForm} onClose={handleHideFeedback}>
        <ScreeningFeedback
          screeningReportData={screeningReportData}
          screeningReportTemplateData={screeningReportTemplateData}
          bookedEventInfo={bookedEventInfo}
          mentorProfileData={mentorProfileData}
          closeDialog={handleHideFeedback}
          showTherapyRecommendation={screeningReportData?.suggestedBookingTherapy}
          afterSubmitFeedback={handleAfterSubmitFeedback}
        />
      </Dialog>
    </>
  )
}
